import React from "react";
import { useSelector } from "react-redux";
import ProductComparisonItem1 from "./ProductComparisonItem1.js";
import ProductComparisonItem2 from "./ProductComparisonItem2.js";
import { Dialog, DialogBody, DialogHeader, IconButton } from "@material-tailwind/react";
import IsiCompare2 from "./IsiCompare2.js";
import { BiAddToQueue } from "react-icons/bi";

const ProductComparison = () => {
  // eslint-disable-next-line no-undef
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(!open);
    compare2();
  }
  const compare2 = () => {
    <div className="right-image mx-4 px-2">
      {compared2.map((item2) => (
        <img
          src={item2.image}
          alt=""
          height="200px"
          width="300px"
        />
      ))}
    </div>
  }
  // const [images, setImages] = useState([]);
  const compared1 = useSelector((state) => state.orebiReducer.compared1);
  const compared2 = useSelector((state) => state.orebiReducer.compared2);
  return (
    <>
      <Dialog className="w-full h-[90%] rounded-lg overflow-auto touch-auto" open={open} size="xl" handler={handleOpen}>
        <DialogHeader className="justify-end">
          <IconButton
            color="blue-gray"
            size="sm"
            variant="text"
            onClick={handleOpen}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
              className="h-5 w-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </IconButton>
        </DialogHeader>
        <DialogBody>
          <IsiCompare2 />
        </DialogBody>
      </Dialog>
      <div class="overflow-x-auto">
        <div className="bg-green-100 mx-auto py-2 px-2 rounded-sm shadow-sm flex justify-between">
          <div class="relative">

            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
              <svg
                class="fill-current h-4 w-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >

                <path d="M9.29289 12.2929C9.68342 12.6834 10.3166 12.6834 10.7071 12.2929L14.7071 8.29289C15.0976 7.90237 15.0976 7.2692 14.7071 6.87868C14.3166 6.48815 13.6834 6.48815 13.2929 6.87868L10 10.1716L6.70711 6.87868C6.31658 6.48815 5.68342 6.48815 5.29289 6.87868C4.90237 7.2692 4.90237 7.90237 5.29289 8.29289L9.29289 12.2929Z" />
              </svg>
            </div>
          </div>
          <div className="mx-auto my-auto text-center">
            Compare Our Products
          </div>
          <div class="relative">
            <button onClick={handleOpen}>
              <BiAddToQueue size="100" />
            </button>
            <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">

            </div>
          </div>
        </div>
        <div className="container mt-4 py-4 mx-auto flex justify-between">
          <div className="left-image mx-4 px-2">
            <p className="mx-auto my-auto text-center mb-4">Product A</p>
            {compared1.map((item1) => (
              <img
                src={item1.image}
                alt=""
                height="200px"
                width="300px"
              />
            ))}
          </div>

          <div className="mx-auto my-auto px-2 py-2">
            <h2 className="font-bold text-4xl py-5">VS</h2>
          </div>
          <div className="right-image mx-4 px-2">
            <div className="right-image mx-4 px-2">
              <p className="mx-auto my-auto text-center mb-4">Product B</p>
              {compared2.map((item2) => (
                <img
                  src={item2.image}
                  alt=""
                  height="200px"
                  width="300px"
                />
              ))}
            </div>
          </div>
        </div>
        <table>
          {compared1.map((item1) => (
            <tbody>

              <ProductComparisonItem1 item={item1} />
            </tbody>

          ))}
          {compared2.map((item2) => (
            <tbody>

              <ProductComparisonItem2 item={item2} />
            </tbody>
          ))}
        </table>
      </div>
    </>
  );
};

export default ProductComparison;
